// @ts-nocheck
/* eslint-disable */

"use client";

import {
  Button,
  Chip,
  Column,
  Cover,
  Heading,
  Icon,
  ImageWrapper,
  RichText,
  Row,
  ShareModal,
  Spacer,
} from "tempdev-ds";
import { useEffect, useState } from "react";

import { AuthorCard } from "tempdev-ds";
import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import GravityForm from "@/components/common/GravityForm/GravityForm";
import Link from "next/link";
import { Taxonomy } from "@/lib/wordpress/_types/archiveGrid";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import { formatDate } from "@/lib/helpers/dateFormate";
import { removeScroll } from "@/lib/helpers/removeScroll";
import { styled } from "styled-components";
import { useGlobalContext } from "@/lib/globalContext";

const StyledPost = styled.div`
  display: block;

  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    margin-top: 4rem;
    margin-bottom: 2.4rem;
  }

  h2 {
    font-size: var(--fontSize-h3);
  }

  & > p {
    margin-bottom: 1.4rem;
  }

  & > div {
    margin-bottom: 1.6rem;
  }

  & > picture {
    margin-bottom: 2rem;
  }

  & > hr {
    margin-bottom: 2rem;
  }

  & .container {
    padding-left: 0;
    padding-right: 0;
  }

  .column {
    & > picture {
      max-width: 100% !important;
    }
  }

  & a {
    min-width: auto;
  }

  & p a,
  & li a {
    color: var(--color-primary70);

    &:hover {
      opacity: 0.8;
    }
  }
`;

const BlogPost = (post: Record<string, unknown>) => {
  const state = useGlobalContext();
  const [shareOpen, setShareOpen] = useState(false);

  useEffect(() => {
    removeScroll(shareOpen, state);
  }, [shareOpen]);

  const categoriesObj = post?.categories.filter(x => x.name === "post_tag") || [];
  const categories = categoriesObj && Object.keys(categoriesObj).length > 0 ? categoriesObj[0]?.items : [];

  const relatedArticles = post?.acf?.related_articles;

  return (
    <div>
      <Spacer height={6} />
      <Row align="center" mobileSpace={true}>
        <Column md={5} mobileOrder={2}>
          <Button
            variant="link"
            href="/blog/"
            leftIcon={<Icon icon="icon-arrow-back"></Icon>}
          >{state?.dict?.custom?.backBlog}</Button>
          <Heading
            size="texts"
            tag="span"
            className="color-gray50 text-uppercase fw-semibold mt-4"
          >
            {formatDate(post?.date as string, "DATE_SHORT")}
          </Heading>
          <Heading size="h2" tag="h1" className="mb-3">
            {post.title}
          </Heading>
          {categories && categories?.length > 0 && (
            <div
              className="d-flex align-items-start flex-wrap"
              style={{ gap: "12px" }}
            >
              {categories.map((cat, i) => {
                return (
                  <Link key={`cat-${i}`} href={`/blog/tag/${cat.slug}`}>
                    <Chip className="mt-2">{cat.name}</Chip>
                  </Link>
                );
              })}
            </div>
          )}
          {post?.author &&
            <AuthorCard
              {...post?.author}
              imageElement={
                <DisplayImage
                  url={post?.author?.img as string}
                  alt={post?.author?.name ? (post?.author?.name as string) : ""}
                  fill={true}
                />
              }
              linkElement={
                <Link
                  href={post?.author?.slug as string}
                  className="linker"
                ></Link>
              }
              className="mt-6"
            />
          }
        </Column>
        <Column md={2}></Column>
        <Column md={5} mobileOrder={1}>
          <ImageWrapper aspectRatioHeight={60}>
            <DisplayImage
              url={post?.image as string}
              alt={post?.title ? (post?.title as string) : ""}
              fill={true}
              className="radius-md"
            />
          </ImageWrapper>
        </Column>
      </Row>
      <Spacer height={6} />
      <Row mobileSpace={true}>
        <Column md={3} className="mt-3" mobileOrder={2}>
          <div className="sticky-element" style={{ top: "6rem" }}>
            {relatedArticles && relatedArticles.length > 0 && (
              <div
                className="bg-white radius-md shadow-md p-4"
                style={{ border: "1px solid #dcdfe5" }}
              >
                <Heading tag="h4" size="h4" className="mb-4">
                  {state?.dict?.blog?.relatedTitle}:
                </Heading>
                {relatedArticles.map((item, i) => {
                  return (
                    <div key={`related-${i}`} className="d-block mb-4">
                      <RichText tag="p">{item.title}</RichText>
                      <Button
                        variant={"link"}
                        href={item.slug}
                        rightIcon={<Icon icon="icon-arrow-link"></Icon>}
                        className={`mt-2`}
                      >
                        {state?.dict?.custom?.readArticle}
                      </Button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </Column>
        <Column md={6} mobileOrder={1} className="mt-3">
          <StyledPost>
            {!!(post?.blocks as [])?.length &&
              (post?.blocks as []).map((block: BlocksProps, index: number) => {
                return displayBlock(block, index);
              })}
          </StyledPost>
        </Column>
        <Column md={3} mobileOrder={3} className="mt-3">
          <div className="sticky-element" style={{ top: "6rem" }}>
            <div
              className="share-holder radius-md radius-md-lg shadow-sm p-4 text-center"
              style={{
                backgroundColor: "#EEFCFB",
              }}
            >
              <Heading tag="h3" size="h5">
                {state?.dict?.custom?.interested}
              </Heading>
              <RichText tag="p" className="mt-3">{state?.dict?.custom?.contactsTitle}</RichText>
              <div className="d-flex align-items-center justify-content-center mt-3">
                <Button
                  variant={"link"}
                  leftIcon={<Icon icon="icon-share" />}
                  className="mt-3"
                  onClick={() => setShareOpen(true)}
                >
                  {state?.dict?.blog?.shareBtn}
                </Button>
              </div>
            </div>
          </div>
        </Column>
      </Row>
      {post?.form && (
        <>
          <Spacer height={8} />
          <Row
            align="center"
            mobileSpace={true}
            className="rounded-section"
            style={{ color: "#343A46", backgroundColor: "#EEF9FC" }}
          >
            <Column md={5}>
              <Heading
                tag="h6"
                size="texts"
                className="color-gray50 text-uppercase"
              >
                {state?.dict?.custom?.interested}
              </Heading>
              <Heading tag="h3" size="h2">{state?.dict?.custom?.blogTitle}</Heading>
              <RichText tag="p" className="mt-3 mb-5">{state?.dict?.custom?.contactsTitle}</RichText>
            </Column>
            <Column md={1}></Column>
            <Column md={6}>
              <GravityForm
                formData={post?.form}
                formId={process.env.NEXT_PUBLIC_BLOG_FORM_ID}
              />
            </Column>
          </Row>
        </>
      )}
      <Spacer height={8} />
      <ShareModal
        siteTitle={process.env.NEXT_PUBLIC_SITE_NAME}
        title={post.title}
        url={`${process.env.NEXT_PUBLIC_FE_URL}${post.slug}`}
        label={(state?.dict?.blog as Record<string, string>)?.shareBtn}
        copyText={(state?.dict?.blog as Record<string, string>)?.shareCopy}
        open={shareOpen}
        onClose={() => setShareOpen(false)}
      ></ShareModal>
    </div>
  );
};
export default BlogPost;
